import { useEffect, useState } from 'react';

const DEFAULT_DEBOUNCE_MS = 300;

export const useDebouncedValue = <T>(
  value: T,
  delayMs: number = DEFAULT_DEBOUNCE_MS,
): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setDebouncedValue(value);
    }, delayMs);

    return () => window.clearTimeout(timer);
  }, [delayMs, value]);

  return debouncedValue;
};
